export default "__VITE_ASSET__BdPUnyhf__"